// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AI Profiling Wizard Stylesheet */

:root {
  --wizard-bg: #0b0f19;
  --wizard-slate-dark: #0f172a;
  --wizard-slate-light: #1e293b;
  --wizard-primary: var(--brand-primary, #0877bc);
  --wizard-primary-dark: var(--brand-primary-dark, #065a8f);
  --wizard-primary-gradient: linear-gradient(135deg, var(--wizard-primary) 0%, var(--wizard-primary-dark) 100%);
  --wizard-accent: var(--brand-primary-light, #0a8cd8);
  --wizard-accent-gradient: linear-gradient(135deg, var(--brand-secondary, #4facfe) 0%, var(--wizard-accent) 100%);
  --wizard-text-main: #f8fafc;
  --wizard-text-muted: #94a3b8;
  --wizard-glass-bg: rgba(15, 23, 42, 0.75);
  --wizard-glass-border: rgba(255, 255, 255, 0.08);
}

.wizard-full-bg {
  position: fixed;
  top: var(--wizard-vv-top, 0px);
  left: 0;
  right: 0;
  width: 100%;
  height: var(--wizard-vvh, 100dvh);
  max-height: var(--wizard-vvh, 100dvh);
  min-height: 0;
  background-color: var(--wizard-bg);
  background-image: 
    radial-gradient(at 0% 0%, color-mix(in srgb, var(--wizard-primary) 15%, transparent) 0px, transparent 50%),
    radial-gradient(at 100% 100%, color-mix(in srgb, var(--wizard-accent) 8%, transparent) 0px, transparent 50%),
    linear-gradient(rgba(255, 255, 255, 0.01) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.01) 1px, transparent 1px);
  background-size: 100% 100%, 100% 100%, 30px 30px, 30px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding:
    max(0.5rem, env(safe-area-inset-top, 0px))
    max(0.75rem, env(safe-area-inset-right, 0px))
    max(0.35rem, var(--wizard-safe-bottom, env(safe-area-inset-bottom, 0px)))
    max(0.75rem, env(safe-area-inset-left, 0px));
  box-sizing: border-box;
  font-family: 'Outfit', 'Inter', -apple-system, sans-serif;
  color: var(--wizard-text-main);
  overflow: hidden;
  z-index: 20;
}

/* 1. Introduction Card */
.wizard-intro-card {
  width: 100%;
  max-width: 640px;
  max-height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--wizard-glass-bg);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid var(--wizard-glass-border);
  border-radius: 24px;
  padding: 2.5rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  overflow-y: auto;
}

.wizard-intro-card:has(> .wizard-intro-card__body) {
  overflow: hidden;
}

.wizard-intro-card__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.wizard-intro-card__cta {
  flex: 0 0 auto;
  padding-top: 0.85rem;
}

.wizard-intro-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  padding-bottom: 1.2rem;
}

.logo-badge {
  font-size: 2.2rem;
  background: rgba(255, 255, 255, 0.05);
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-boot-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.1rem;
  padding: 2rem 1.25rem;
  text-align: center;
}

.invite-splash-screen {
  width: 100%;
  min-height: var(--wizard-vvh, 100dvh);
  height: var(--wizard-vvh, 100dvh);
  background: #ffffff;
  color: #111827;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: max(0.5rem, env(safe-area-inset-top, 0px)) max(0.75rem, env(safe-area-inset-right, 0px)) max(0.5rem, env(safe-area-inset-bottom, 0px)) max(0.75rem, env(safe-area-inset-left, 0px));
  box-sizing: border-box;
}

.invite-splash-screen .intro-body-text {
  color: #111827;
}

.invite-splash-logos {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
}

.invite-splash-logos__club,
.invite-splash-logos__smarttt {
  object-fit: contain;
  display: block;
}

.invite-splash-logos__club {
  width: 128px;
  height: 128px;
  padding: 0;
  border-radius: 22px;
  background: transparent;
  box-sizing: border-box;
}

.invite-splash-logos__smarttt {
  width: 112px;
  height: auto;
  max-height: 128px;
}

.logo-badge--digiping {
  background: radial-gradient(
    circle at 30% 25%,
    color-mix(in srgb, var(--wizard-accent) 20%, transparent),
    color-mix(in srgb, var(--wizard-primary) 12%, transparent) 55%,
    rgba(15, 23, 42, 0.6)
  );
  border-color: color-mix(in srgb, var(--wizard-accent) 35%, transparent);
  box-shadow: 0 0 24px color-mix(in srgb, var(--wizard-accent) 15%, transparent);
}

.wizard-intro-titles {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}

.wizard-join-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem 0.55rem;
  width: fit-content;
  max-width: 100%;
}

.wizard-join-banner {
  display: inline-flex;
  align-items: center;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--wizard-text-main);
  background: color-mix(in srgb, var(--wizard-primary) 22%, transparent);
  border: 1px solid color-mix(in srgb, var(--wizard-primary) 40%, transparent);
  border-radius: 999px;
  padding: 0.28rem 0.75rem;
  margin-bottom: 0.15rem;
  width: fit-content;
}

.wizard-join-banner--compact {
  font-size: 0.72rem;
  padding: 0.18rem 0.6rem;
}

.wizard-intro-card .lang-shortcut--invite .lang-shortcut__btn {
  background: color-mix(in srgb, var(--wizard-primary, #0877bc) 22%, transparent);
  border: 1px solid color-mix(in srgb, var(--wizard-primary, #0877bc) 40%, transparent);
  color: var(--wizard-text-main, #f8fafc);
  box-shadow: none;
}

.wizard-intro-card .lang-shortcut--invite .lang-shortcut__btn:hover {
  transform: scale(1.04);
  background: color-mix(in srgb, var(--wizard-primary, #0877bc) 32%, transparent);
}

.wizard-intro-card .lang-shortcut--invite .lang-shortcut__btn.is-open {
  background: var(--wizard-primary, #0877bc);
  border-color: var(--wizard-primary, #0877bc);
  color: #fff;
}

.wizard-intro-card .lang-shortcut--invite .lang-shortcut__panel {
  background: rgba(15, 23, 42, 0.96);
  color: #f8fafc;
  border: 1px solid color-mix(in srgb, var(--wizard-primary, #0877bc) 35%, transparent);
}

.wizard-intro-card .lang-shortcut--invite .lang-shortcut__option {
  color: #f8fafc;
}

.wizard-join-logo {
  width: 44px;
  height: 44px;
  object-fit: contain;
  border-radius: 12px;
}

.wizard-join-logo--sm {
  width: 28px;
  height: 28px;
  border-radius: 8px;
}

.digiping-tag {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--wizard-accent);
}

.wizard-intro-header h2 {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  background: linear-gradient(to right, #ffffff, #94a3b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.intro-body-text {
  font-size: 1.05rem;
  line-height: 1.6;
  color: var(--wizard-text-muted);
  margin-bottom: 1.8rem;
}

.intro-body-text .dp-rich-text,
.intro-body-text .dp-rich-p {
  margin: 0;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}

.intro-body-text.typewriter-streaming,
.intro-action-prompt.typewriter-streaming {
  position: relative;
}

.intro-body-text.typewriter-streaming > .dp-rich-text,
.intro-action-prompt.typewriter-streaming > .dp-rich-text,
.intro-body-text.typewriter-streaming .dp-rich-p,
.intro-action-prompt.typewriter-streaming .dp-rich-p,
.intro-body-text.typewriter-streaming .dp-rich-line,
.intro-action-prompt.typewriter-streaming .dp-rich-line {
  display: inline;
}

.intro-body-text .typewriter-caret,
.intro-action-prompt .typewriter-caret,
.smart-desc .typewriter-caret,
.typewriter-streaming > .typewriter-caret {
  display: inline-block;
  width: 2px;
  height: 1.05em;
  margin-left: 2px;
  vertical-align: text-bottom;
  background: var(--wizard-accent, #22d3ee);
  border-radius: 1px;
  animation: typewriterBlink 0.85s step-end infinite;
}

.smart-bullet--streaming {
  border-color: rgba(8, 119, 188, 0.35);
  background: rgba(8, 119, 188, 0.06);
}

.intro-stream-status {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-top: 0.5rem;
  color: var(--wizard-text-muted);
  font-size: 0.9rem;
}

.intro-stream-status__label {
  opacity: 0.85;
}

/* SMART Grid */
.smart-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 2rem;
}

.smart-bullet {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.04);
  padding: 0.95rem 1.1rem;
  border-radius: 14px;
  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}

.smart-bullet:hover {
  transform: translateX(4px);
  border-color: rgba(8, 119, 188, 0.3);
  background: rgba(8, 119, 188, 0.02);
}

.smart-letter {
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.95rem;
  letter-spacing: 0.02em;
  color: #0b0f19;
}

.smart-bullet--s .smart-letter { background: linear-gradient(135deg, #22d3ee, #0891b2); }
.smart-bullet--m .smart-letter { background: linear-gradient(135deg, #34d399, #059669); }
.smart-bullet--a .smart-letter { background: linear-gradient(135deg, #fbbf24, #d97706); }
.smart-bullet--r .smart-letter { background: linear-gradient(135deg, #fb7185, #e11d48); }
.smart-bullet--t .smart-letter { background: linear-gradient(135deg, #a78bfa, #7c3aed); }

.smart-bullet-copy {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
}

.smart-label {
  font-size: 0.98rem;
  line-height: 1.3;
}

.smart-desc {
  font-size: 0.92rem;
  line-height: 1.45;
  color: var(--wizard-text-muted);
}

.smart-desc.dp-rich-text,
.smart-desc .dp-rich-p,
.smart-desc .dp-rich-line {
  margin: 0;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}

/* Digiping emphasis (replaces **markdown**) */
.dp-em {
  font-weight: 800;
  font-style: normal;
  letter-spacing: 0.02em;
  font-family: 'Outfit', 'Avenir Next', 'Segoe UI', sans-serif;
}

.dp-em--s,
.dp-em--specific { color: #22d3ee; }
.dp-em--m { color: #34d399; }
.dp-em--a { color: #fbbf24; }
.dp-em--r { color: #fb7185; }
.dp-em--t { color: #a78bfa; }
.dp-em--smart {
  background: var(--wizard-accent-gradient);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: var(--wizard-accent);
}
.dp-em--goal { color: #38bdf8; }
.dp-em--default { color: var(--wizard-accent); }

.dp-rich-text {
  margin: 0;
}

.dp-rich-line {
  display: inline;
}

.dp-rich-bullet {
  position: relative;
  padding-left: 1.05rem;
  margin: 0.45rem 0 0.15rem;
  line-height: 1.55;
}

.dp-rich-bullet::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.55em;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background: var(--wizard-accent);
  box-shadow: 0 0 8px rgba(0, 242, 254, 0.55);
}

.intro-action-prompt {
  font-size: 1rem;
  color: var(--wizard-accent);
  font-weight: 500;
  margin-bottom: 1.5rem;
  text-align: center;
}

.wizard-begin-btn {
  width: 100%;
  padding: 1.1rem;
  border-radius: 14px;
  border: none;
  background: var(--wizard-primary-gradient);
  color: var(--wizard-text-main);
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  box-shadow: 0 10px 20px -5px rgba(8, 119, 188, 0.4);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.wizard-begin-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px -5px rgba(8, 119, 188, 0.6);
  filter: brightness(1.1);
}

.intro-resume-hint {
  margin: 0 0 1rem;
  font-size: 0.95rem;
  color: var(--wizard-text-muted, rgba(255, 255, 255, 0.72));
  text-align: center;
}

.wizard-begin-btn--secondary {
  margin-top: 0.75rem;
  background: transparent;
  border: 1px solid var(--wizard-glass-border, rgba(255, 255, 255, 0.2));
  box-shadow: none;
  font-size: 0.95rem;
}

.wizard-begin-btn--secondary:hover {
  box-shadow: none;
  filter: none;
  background: rgba(255, 255, 255, 0.06);
}

/* 2. Chat Interface Container */
.wizard-chat-container {
  width: 100%;
  max-width: 760px;
  flex: 1 1 auto;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  background: var(--wizard-glass-bg);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--wizard-glass-border);
  border-radius: 28px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 30px 60px -15px rgba(0, 0, 0, 0.6);
}

.wizard-chat-header {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem 1.25rem 0.85rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(8, 15, 28, 0.55);
}

.wizard-chat-header__brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.wizard-chat-header__brand .lang-shortcut--invite {
  margin-left: auto;
}

.wizard-chat-header__brand .lang-shortcut--invite .lang-shortcut__panel {
  right: 0;
  left: auto;
}

.wizard-chat-header__text {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
}

.wizard-chat-header__text .coach-label {
  margin-bottom: 0;
}

.coach-avatar--header {
  width: 36px;
  height: 36px;
}

.coach-label-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem 0.65rem;
  margin-bottom: 0.4rem;
}

.coach-label-row .coach-label {
  margin-bottom: 0;
}

.dimension-chip {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

/* Digiping SMART progress rail */
.digiping-smart-rail {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.digiping-smart-rail__track {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0;
  padding-bottom: 0.65rem;
}

.digiping-smart-rail__link {
  flex: 1 1;
  height: 2px;
  margin: 0 0.2rem;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.08);
  transition: background 0.3s ease;
}

.digiping-smart-rail__link--complete,
.digiping-smart-rail__link--partial {
  background: linear-gradient(90deg, rgba(79, 172, 254, 0.55), rgba(0, 242, 254, 0.35));
}

.digiping-smart-rail__node {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 1.5px solid rgba(255, 255, 255, 0.12);
  background: rgba(15, 23, 42, 0.9);
  color: var(--wizard-text-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: default;
  flex-shrink: 0;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease, background 0.25s ease;
}

.digiping-smart-rail__node:disabled {
  opacity: 1;
}

.digiping-smart-rail__node:not(:disabled) {
  cursor: pointer;
}

.digiping-smart-rail__letter {
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.digiping-smart-rail__node.is-empty {
  opacity: 0.55;
}

.digiping-smart-rail__node.is-partial {
  animation: digipingPulse 1.6s ease-in-out infinite;
}

.digiping-smart-rail__node.is-complete {
  color: #0b0f19;
  border-color: transparent;
}

.digiping-smart-rail__node--s.is-complete { background: linear-gradient(135deg, #22d3ee, #0891b2); }
.digiping-smart-rail__node--m.is-complete { background: linear-gradient(135deg, #34d399, #059669); }
.digiping-smart-rail__node--a.is-complete { background: linear-gradient(135deg, #fbbf24, #d97706); }
.digiping-smart-rail__node--r.is-complete { background: linear-gradient(135deg, #fb7185, #e11d48); }
.digiping-smart-rail__node--t.is-complete { background: linear-gradient(135deg, #a78bfa, #7c3aed); }

.digiping-smart-rail__node.is-active {
  opacity: 1;
  z-index: 2;
  transform: scale(1.18);
  outline: 2px solid currentColor;
  outline-offset: 3px;
  box-shadow:
    0 0 0 4px rgba(0, 242, 254, 0.35),
    0 10px 24px rgba(0, 242, 254, 0.28);
  border-color: currentColor;
}

.digiping-smart-rail__node--s.is-active {
  color: #0891b2;
  box-shadow: 0 0 0 4px color-mix(in srgb, #22d3ee 45%, transparent), 0 10px 24px color-mix(in srgb, #22d3ee 32%, transparent);
}
.digiping-smart-rail__node--m.is-active {
  color: #059669;
  box-shadow: 0 0 0 4px color-mix(in srgb, #34d399 45%, transparent), 0 10px 24px color-mix(in srgb, #34d399 32%, transparent);
}
.digiping-smart-rail__node--a.is-active {
  color: #d97706;
  box-shadow: 0 0 0 4px color-mix(in srgb, #fbbf24 45%, transparent), 0 10px 24px color-mix(in srgb, #fbbf24 32%, transparent);
}
.digiping-smart-rail__node--r.is-active {
  color: #e11d48;
  box-shadow: 0 0 0 4px color-mix(in srgb, #fb7185 45%, transparent), 0 10px 24px color-mix(in srgb, #fb7185 32%, transparent);
}
.digiping-smart-rail__node--t.is-active {
  color: #7c3aed;
  box-shadow: 0 0 0 4px color-mix(in srgb, #a78bfa 45%, transparent), 0 10px 24px color-mix(in srgb, #a78bfa 32%, transparent);
}

.digiping-smart-rail__node.is-active.is-complete {
  color: #0b0f19;
  outline-color: rgba(255, 255, 255, 0.85);
}

.digiping-smart-rail__node.is-coach-pending {
  position: relative;
  border-color: rgba(251, 191, 36, 0.75);
}

.digiping-smart-rail__coach {
  position: absolute;
  bottom: -0.55rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.5rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  padding: 0.1rem 0.28rem;
  border-radius: 4px;
  background: rgba(251, 191, 36, 0.95);
  color: #1a1408;
  line-height: 1.1;
}

.digiping-smart-rail__caption {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: center;
}

.digiping-coach-banner {
  margin: 0.35rem 0 0.85rem;
  padding: 0.65rem 0.8rem;
  border-radius: 10px;
  background: rgba(251, 191, 36, 0.12);
  border: 1px solid rgba(251, 191, 36, 0.35);
  color: var(--wizard-text-muted);
  font-size: 0.88rem;
  line-height: 1.4;
}

.digiping-coach-pill {
  display: inline-block;
  margin-left: 0.4rem;
  padding: 0.08rem 0.35rem;
  border-radius: 4px;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  vertical-align: middle;
  background: rgba(251, 191, 36, 0.95);
  color: #1a1408;
}

.digiping-snapshot-row.has-coach-badge {
  border-color: rgba(251, 191, 36, 0.35);
}

.digiping-tray-input {
  width: 100%;
  margin-top: 0.55rem;
}

.digiping-training-volume-tray .tray-subtitle {
  margin-top: 0.65rem;
}

.digiping-training-volume-tray .tray-subtitle:first-child {
  margin-top: 0;
}

.digiping-training-volume-tray .badge-grid {
  margin-bottom: 0.25rem;
}

.digiping-metric-target-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.55rem;
}

.digiping-metric-unit {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--wizard-text-muted);
  white-space: nowrap;
}

.digiping-coach-hint {
  color: rgba(251, 191, 36, 0.95) !important;
}

.digiping-milestone-chip {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
}

.digiping-horizon-tag {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  padding: 0.12rem 0.35rem;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.9);
}

@keyframes digipingPulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(0, 242, 254, 0.0); }
  50% { box-shadow: 0 0 0 4px rgba(0, 242, 254, 0.18); }
}

/* Digiping SMART snapshot (assessment) */
.digiping-snapshot-card .assessment-body {
  margin-top: 1rem;
}

.digiping-snapshot-grid {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  opacity: 0;
  transform: translateY(6px);
  transition: opacity 0.35s ease, transform 0.35s ease;
}

.digiping-snapshot-grid.is-visible {
  opacity: 1;
  transform: none;
}

.digiping-snapshot-row {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.7rem 0.85rem;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.digiping-snapshot-letter {
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.85rem;
  color: #0b0f19;
  flex-shrink: 0;
}

.digiping-snapshot-row--s .digiping-snapshot-letter { background: linear-gradient(135deg, #22d3ee, #0891b2); }
.digiping-snapshot-row--m .digiping-snapshot-letter { background: linear-gradient(135deg, #34d399, #059669); }
.digiping-snapshot-row--a .digiping-snapshot-letter { background: linear-gradient(135deg, #fbbf24, #d97706); }
.digiping-snapshot-row--r .digiping-snapshot-letter { background: linear-gradient(135deg, #fb7185, #e11d48); }
.digiping-snapshot-row--t .digiping-snapshot-letter { background: linear-gradient(135deg, #a78bfa, #7c3aed); }

.digiping-snapshot-copy {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.digiping-snapshot-summary {
  font-size: 0.88rem;
  line-height: 1.4;
  color: var(--wizard-text-muted);
}

/* Chat History Stream */
.wizard-chat-history {
  flex: 1 1 auto;
  min-height: 0;
  padding: 1.5rem 2rem 1.25rem;
  overflow-y: auto;
  overscroll-behavior: contain;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
}

.wizard-chat-history__spacer {
  flex: 0 0 auto;
  height: 0.5rem;
  width: 100%;
  pointer-events: none;
}

.wizard-chat-history::-webkit-scrollbar {
  width: 6px;
}

.wizard-chat-history::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

/* Chat Rows & Bubbles */
.ai-row {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  align-self: flex-start;
  max-width: 80%;
}

.user-row {
  align-self: flex-end;
  max-width: 80%;
}

.system-row {
  align-self: center;
  max-width: 90%;
  margin: 0.8rem 0;
}

.coach-avatar {
  width: 38px;
  height: 38px;
  background: radial-gradient(
    circle at 30% 25%,
    color-mix(in srgb, var(--wizard-accent) 28%, transparent),
    color-mix(in srgb, var(--wizard-primary) 45%, transparent) 60%,
    var(--wizard-primary-dark)
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid color-mix(in srgb, var(--wizard-accent) 35%, transparent);
  box-shadow: 0 4px 14px color-mix(in srgb, var(--wizard-accent) 18%, transparent);
  flex-shrink: 0;
  overflow: hidden;
}

.digiping-mark {
  display: block;
  flex-shrink: 0;
}

.ai-bubble {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 4px 18px 18px 18px;
  padding: 1rem 1.3rem;
  position: relative;
}

.coach-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--wizard-accent);
  display: block;
  margin-bottom: 0.4rem;
}

.user-bubble {
  background: var(--wizard-primary-gradient);
  border-radius: 18px 18px 4px 18px;
  padding: 1rem 1.3rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 16px -4px rgba(8, 119, 188, 0.3);
}

.user-answer-row {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.45rem;
}

.edit-answer-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin: 0;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(0, 0, 0, 0.18);
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.edit-answer-btn:hover {
  background: rgba(0, 0, 0, 0.32);
  border-color: rgba(255, 255, 255, 0.45);
}

.editing-hint {
  margin: 0 0 0.75rem;
  text-align: center;
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--wizard-accent);
}

.msg-content-text {
  font-size: 1.02rem;
  line-height: 1.5;
  margin: 0;
  white-space: pre-wrap;
}

.typewriter-text {
  min-height: 1.5em;
}

.typewriter-caret {
  display: inline-block;
  width: 2px;
  height: 1.05em;
  margin-left: 2px;
  vertical-align: text-bottom;
  background: var(--wizard-accent);
  border-radius: 1px;
  animation: typewriterBlink 0.85s step-end infinite;
}

@keyframes typewriterBlink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

/* System Messages */
.system-msg-box {
  background: rgba(8, 119, 188, 0.12);
  border: 1px solid rgba(8, 119, 188, 0.25);
  border-radius: 12px;
  padding: 0.8rem 1.5rem;
  text-align: center;
}

.system-msg-box p {
  margin: 0;
  font-size: 0.95rem;
  color: #c0e0ff;
  font-weight: 500;
}

/* 3. Typing Indicator Animation */
.typing-bubble {
  display: flex;
  flex-direction: column;
}

.typing-indicator-dots {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 20px;
}

.typing-indicator-dots span {
  width: 8px;
  height: 8px;
  background: var(--wizard-text-muted);
  border-radius: 50%;
  display: inline-block;
  animation: bounceDot 1.4s infinite ease-in-out both;
}

.typing-indicator-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.typing-indicator-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes bounceDot {
  0%, 80%, 100% { 
    transform: scale(0);
  } 40% { 
    transform: scale(1.0);
  }
}

/* 4. Interactive Footer Options Tray */
.wizard-interactive-footer {
  flex: 0 0 auto;
  max-height: min(36dvh, calc(var(--wizard-vvh, 100dvh) * 0.36), 280px);
  overflow-y: auto;
  overscroll-behavior: contain;
  background: rgba(10, 15, 28, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 0.65rem 1.25rem 0.85rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -12px 28px rgba(0, 0, 0, 0.35);
  scroll-margin-bottom: 0.35rem;
}

html.wizard-keyboard-open .wizard-interactive-footer,
body.wizard-keyboard-open .wizard-interactive-footer {
  max-height: min(42dvh, calc(var(--wizard-vvh, 100dvh) * 0.42), 220px);
  padding-bottom: 0.35rem;
}

html.wizard-keyboard-open .wizard-full-bg,
body.wizard-keyboard-open .wizard-full-bg {
  padding-bottom: 0.25rem;
}

html.wizard-keyboard-open .inline-input-field,
html.wizard-keyboard-open .inline-input-field:focus,
body.wizard-keyboard-open .inline-input-field,
body.wizard-keyboard-open .inline-input-field:focus {
  scroll-margin-bottom: 0.35rem;
}

/* Confirm trays: options scroll; Continue stays in the visible footer. */
.wizard-interactive-footer:has(.options-badge-tray--sticky-confirm) {
  overflow: hidden;
  max-height: min(48dvh, calc(var(--wizard-vvh, 100dvh) * 0.48), 380px);
}

.options-badge-tray--sticky-confirm {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.options-badge-tray--sticky-confirm .badge-grid {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.options-badge-tray--sticky-confirm .tray-confirm-btn {
  flex-shrink: 0;
  width: 100%;
  justify-content: center;
  margin-top: 0.35rem;
}

.options-badge-tray--sticky-confirm .tray-confirm-hint {
  flex-shrink: 0;
  margin: 0;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--wizard-text-muted);
  text-align: center;
}

.options-badge-tray--sticky-confirm .tray-confirm-hint kbd {
  display: inline-block;
  padding: 0.05rem 0.35rem;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.06);
  font-size: 0.7rem;
  font-family: inherit;
}

.wizard-interactive-footer--assessment {
  overflow: hidden;
  max-height: min(72dvh, calc(var(--wizard-vvh, 100dvh) * 0.72), 640px);
  /* Extra floor for Android gesture / Samsung nav when env() reports 0 */
  padding-bottom: max(
    1rem,
    calc(env(safe-area-inset-bottom, 0px) + 16px),
    var(--wizard-safe-bottom, 0px)
  );
}

.wizard-interactive-footer:has(.assessment-tray--sticky-cta) {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.assessment-tray--sticky-cta {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  overflow: hidden;
  width: 100%;
}

.assessment-tray--sticky-cta .assessment-card--body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.assessment-tray--sticky-cta .assessment-btn {
  flex-shrink: 0;
  width: 100%;
  margin-top: 0;
  /* Keep CTA clear of OS bottom chrome */
  margin-bottom: max(0px, calc(env(safe-area-inset-bottom, 0px) * 0.15));
  box-shadow: 0 -10px 24px rgba(10, 15, 28, 0.55);
  z-index: 2;
}

/* Options Tray layout for cards */
.options-tray {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.tray-card {
  flex: 1 1 180px;
  max-width: 230px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 1.2rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  transition: all 0.25s cubic-bezier(0.25, 1, 0.5, 1);
  color: var(--wizard-text-main);
}

.tray-card:hover {
  background: rgba(8, 119, 188, 0.06);
  border-color: rgba(8, 119, 188, 0.4);
  transform: translateY(-3px);
  box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.4);
}

.tray-icon {
  font-size: 2rem !important;
  color: var(--wizard-accent);
}

.tray-card-title {
  font-size: 0.98rem;
  font-weight: 600;
  text-align: center;
}

/* Badge selector tray layout */
.options-badge-tray {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.tray-subtitle {
  font-size: 0.95rem;
  color: var(--wizard-text-muted);
  margin: 0 0 0.2rem 0;
  font-weight: 500;
}

.badge-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
}

.max-height-tray {
  max-height: 180px;
  overflow-y: auto;
  padding-right: 0.5rem;
}

.badge-button {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  padding: 0.75rem 1.1rem;
  font-size: 0.92rem;
  font-weight: 500;
  color: var(--wizard-text-main);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.badge-button:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.15);
  transform: translateY(-1px);
}

.badge-button.active-badge {
  background: var(--wizard-primary-gradient);
  border-color: rgba(8, 119, 188, 0.5);
  box-shadow: 0 4px 12px rgba(8, 119, 188, 0.3);
}

.flag-span {
  font-size: 1.2rem;
}

.align-left {
  justify-content: flex-start;
  text-align: left;
  width: calc(50% - 0.3rem);
  flex-grow: 1;
}

.tray-confirm-btn {
  align-self: flex-end;
  padding: 0.75rem 1.5rem;
  background: var(--wizard-accent-gradient);
  border: none;
  color: #0b0f19;
  font-weight: 700;
  border-radius: 12px;
  font-size: 0.95rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 242, 254, 0.25);
  transition: all 0.2s ease;
}

.tray-confirm-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.tray-confirm-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 16px rgba(0, 242, 254, 0.45);
}

.tray-confirm-btn:focus-visible {
  outline: 2px solid #00f2fe;
  outline-offset: 3px;
}

/* 5. In-chat forms (Inputs & Autocomplete) */
.search-input-wrapper {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 0.6rem 1rem;
  margin-bottom: 0.5rem;
}

.search-field-icon {
  color: var(--wizard-text-muted);
}

.search-input-field {
  background: transparent;
  border: none;
  outline: none;
  color: var(--wizard-text-main);
  font-size: 0.98rem;
  width: 100%;
  scroll-margin-bottom: 1.5rem;
}

.inline-text-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.inline-input-wrapper {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 0.6rem 1rem;
}

.inline-input-field {
  background: transparent;
  border: none;
  outline: none;
  color: var(--wizard-text-main);
  font-size: 1.05rem;
  width: 100%;
  scroll-margin-bottom: 0.5rem;
}

.inline-submit-btn {
  background: var(--wizard-primary-gradient);
  border: none;
  color: white;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.inline-submit-btn:hover {
  transform: scale(1.05);
}

.inline-error-text {
  font-size: 0.88rem;
  color: #ff4a5a;
  margin: 0.2rem 0 0 0.5rem;
}

.inline-error-login-link {
  color: var(--brand-primary, #0877bc);
  font-weight: 700;
  text-decoration: underline;
  white-space: nowrap;
}

.inline-error-login-link:hover {
  opacity: 0.9;
}

/* Password double forms */
.password-form-tray {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.password-fields-row {
  display: flex;
  gap: 1rem;
}

.password-input-group {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 0.6rem 1rem;
  scroll-margin-bottom: 1.5rem;
}

.password-submit-btn {
  align-self: flex-end;
  padding: 0.8rem 1.8rem;
  background: var(--wizard-accent-gradient);
  border: none;
  color: #0b0f19;
  font-weight: 700;
  border-radius: 12px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s ease;
}

.password-submit-btn:hover {
  transform: translateY(-1px);
}

/* 6. Assessment Dashboard */
.assessment-tray {
  width: 100%;
}

.assessment-card {
  background: linear-gradient(135deg, rgba(8, 119, 188, 0.12) 0%, rgba(0, 242, 254, 0.05) 100%);
  border: 1px solid rgba(8, 119, 188, 0.25);
  border-radius: 20px;
  padding: 1.8rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.assessment-card h3 {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  color: var(--wizard-accent);
}

.assessment-card-head {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.assessment-body {
  font-size: 0.98rem;
  line-height: 1.6;
  color: #e2e8f0;
  margin: 0 0 1.5rem 0;
  white-space: normal;
}

.assessment-btn {
  width: 100%;
  padding: 1rem;
  background: var(--wizard-primary-gradient);
  border: none;
  color: white;
  font-weight: 600;
  font-size: 1.05rem;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  transition: all 0.2s ease;
}

.assessment-btn:hover {
  filter: brightness(1.1);
  transform: translateY(-1px);
}

/* Ripple effect utility */
.ripple {
  position: relative;
  overflow: hidden;
}

/* Micro-animations */
.animate-fade-in {
  animation: fadeIn 0.45s ease both;
}

.animate-slide-up {
  animation: slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.animate-scale-up {
  animation: scaleUp 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(18px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes scaleUp {
  from { opacity: 0; transform: scale(0.92); }
  to { opacity: 1; transform: scale(1); }
}

/* Responsive adjustments */
@media (max-width: 640px) {
  .wizard-full-bg {
    padding:
      max(0.5rem, env(safe-area-inset-top, 0px))
      max(0.5rem, env(safe-area-inset-right, 0px))
      max(0.5rem, calc(env(safe-area-inset-bottom, 0px) + 12px), var(--wizard-safe-bottom, 0px))
      max(0.5rem, env(safe-area-inset-left, 0px));
  }
  
  .wizard-intro-card {
    padding: 1.25rem 1.15rem 1rem;
  }
  
  .wizard-intro-header h2 {
    font-size: 1.4rem;
  }

  .wizard-chat-container {
    height: 100%;
    max-height: 100%;
    border-radius: 18px;
  }

  .wizard-chat-header {
    padding: 0.75rem 0.9rem 0.65rem;
  }

  .digiping-smart-rail__node {
    width: 1.7rem;
    height: 1.7rem;
  }

  .digiping-smart-rail__letter {
    font-size: 0.68rem;
  }

  .wizard-interactive-footer {
    max-height: min(38dvh, 260px);
    padding: 0.65rem 0.9rem max(
      0.65rem,
      calc(env(safe-area-inset-bottom, 0px) + 12px),
      var(--wizard-safe-bottom, 0px)
    );
  }

  html.wizard-keyboard-open .wizard-interactive-footer,
  body.wizard-keyboard-open .wizard-interactive-footer {
    max-height: min(40dvh, 200px);
    padding-bottom: 0.3rem;
  }

  .wizard-interactive-footer:has(.options-badge-tray--sticky-confirm) {
    max-height: min(52dvh, 360px);
  }

  .wizard-interactive-footer--assessment {
    max-height: min(68dvh, calc(var(--wizard-vvh, 100dvh) * 0.68), 520px);
    padding-bottom: max(
      1rem,
      calc(env(safe-area-inset-bottom, 0px) + 20px),
      var(--wizard-safe-bottom, 0px)
    );
  }

  .assessment-tray--sticky-cta .assessment-btn {
    padding: 0.9rem 1rem;
    font-size: 1rem;
  }

  .ai-bubble, .user-bubble {
    padding: 0.8rem 1.1rem;
  }

  .msg-content-text {
    font-size: 0.95rem;
  }

  .options-tray {
    gap: 0.6rem;
  }

  .tray-card {
    flex: 1 1 120px;
    padding: 0.8rem;
    border-radius: 12px;
  }

  .tray-icon {
    font-size: 1.5rem !important;
  }

  .tray-card-title {
    font-size: 0.85rem;
  }

  .align-left {
    width: 100%;
  }

  .password-fields-row {
    flex-direction: column;
    gap: 0.8rem;
  }
}

.leisure-fun-challenge-card {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem 0;
}

.health-multi-choice {
  display: grid;
  gap: 12px;
  width: 100%;
}

.leisure-fun-challenge-details {
  display: grid;
  gap: 0.75rem;
  margin: 0;
}

.leisure-fun-challenge-details dt {
  font-size: 0.75rem;
  font-weight: 600;
  opacity: 0.75;
  margin-bottom: 0.15rem;
}

.leisure-fun-challenge-details dd {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.35;
}

.leisure-fun-challenge-cta {
  margin-top: 0.25rem;
}

.options-tray .club-admin-health-intro {
  width: 100%;
  margin: 0 0 0.75rem;
}

.options-tray .club-admin-health-intro .who-capsule,
.options-tray .club-admin-health-intro .scforh-intro {
  max-height: 42vh;
  overflow-y: auto;
}

/* Player profiling chat: thin title, conversation fills the viewport. */
.wizard-full-bg.wizard-full-bg--chat {
  justify-content: stretch;
  align-items: stretch;
  padding:
    env(safe-area-inset-top, 0px)
    env(safe-area-inset-right, 0px)
    env(safe-area-inset-bottom, 0px)
    env(safe-area-inset-left, 0px);
}

.wizard-chat-container.wizard-chat-container--fill {
  max-width: none;
  width: 100%;
  height: 100%;
  border-radius: 0;
  border-left: none;
  border-right: none;
  box-shadow: none;
}

.wizard-chat-header.wizard-chat-header--compact {
  flex-direction: row;
  align-items: center;
  gap: 0;
  padding: 0.28rem 0.7rem;
}

.wizard-chat-header--compact .wizard-chat-header__brand {
  flex: 1 1 auto;
  min-width: 0;
  gap: 0.45rem;
}

.wizard-chat-header--compact .coach-avatar--header {
  width: 26px;
  height: 26px;
}

.wizard-chat-header--compact .wizard-join-logo--sm {
  width: 22px;
  height: 22px;
}

.wizard-chat-header--compact .wizard-chat-header__text {
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.4rem;
  min-width: 0;
  overflow: hidden;
}

.wizard-chat-header--compact .wizard-chat-header__text .coach-label {
  font-size: 0.78rem;
  letter-spacing: 0.04em;
  margin-bottom: 0;
  white-space: nowrap;
  flex: 0 0 auto;
}

.wizard-chat-header--compact .wizard-chat-header__text .digiping-tag {
  font-size: 0.62rem;
  letter-spacing: 0.06em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.wizard-chat-header--compact .wizard-join-banner--compact {
  margin-bottom: 0;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 38%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wizard-full-bg--chat .wizard-chat-history {
  padding: 0.7rem 1rem 0.6rem;
  gap: 1rem;
}

@media (max-width: 640px) {
  .wizard-full-bg.wizard-full-bg--chat {
    padding:
      env(safe-area-inset-top, 0px)
      env(safe-area-inset-right, 0px)
      max(0.2rem, env(safe-area-inset-bottom, 0px), var(--wizard-safe-bottom, 0px))
      env(safe-area-inset-left, 0px);
  }

  .wizard-chat-header.wizard-chat-header--compact {
    padding: 0.22rem 0.55rem;
  }

  .wizard-full-bg--chat .wizard-chat-history {
    padding: 0.55rem 0.7rem 0.45rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AIProfilingWizard.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAInC;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;EAC7B,+CAA+C;EAC/C,yDAAyD;EACzD,6GAA6G;EAC7G,oDAAoD;EACpD,gHAAgH;EAChH,2BAA2B;EAC3B,4BAA4B;EAC5B,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iCAAiC;EACjC,qCAAqC;EACrC,aAAa;EACb,kCAAkC;EAClC;;;;0EAIwE;EACxE,2DAA2D;EAC3D,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB;;;;gDAI8C;EAC9C,sBAAsB;EACtB,yDAAyD;EACzD,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,4CAA4C;EAC5C,mBAAmB;EACnB,eAAe;EACf,gDAAgD;EAChD,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,4LAA4L;EAC5L,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;;;;;GAKC;EACD,uEAAuE;EACvE,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,sEAAsE;EACtE,4EAA4E;EAC5E,oBAAoB;EACpB,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,+EAA+E;EAC/E,qFAAqF;EACrF,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,+EAA+E;AACjF;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,qFAAqF;AACvF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;;;EAME,eAAe;AACjB;;AAEA;;;;EAIE,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,yCAAyC;EACzC,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,qCAAqC;EACrC,2CAA2C;EAC3C,uBAAuB;EACvB,mBAAmB;EACnB,6EAA6E;AAC/E;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,iCAAiC,qDAAqD,EAAE;AACxF,iCAAiC,qDAAqD,EAAE;AACxF,iCAAiC,qDAAqD,EAAE;AACxF,iCAAiC,qDAAqD,EAAE;AACxF,iCAAiC,qDAAqD,EAAE;;AAExF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;;EAGE,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA;mBACmB,cAAc,EAAE;AACnC,YAAY,cAAc,EAAE;AAC5B,YAAY,cAAc,EAAE;AAC5B,YAAY,cAAc,EAAE;AAC5B,YAAY,cAAc,EAAE;AAC5B;EACE,yCAAyC;EACzC,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,2BAA2B;AAC7B;AACA,eAAe,cAAc,EAAE;AAC/B,kBAAkB,2BAA2B,EAAE;;AAE/C;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mDAAmD;EACnD,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;EACnD,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0DAA0D;EAC1D,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sEAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qCAAqC;AACvC;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;EAC7B,kDAAkD;EAClD,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,MAAM;EACN,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;EAEE,qFAAqF;AACvF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,iCAAiC;EACjC,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,cAAc;EACd,uGAAuG;AACzG;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,4CAA4C,qDAAqD,EAAE;AACnG,4CAA4C,qDAAqD,EAAE;AACnG,4CAA4C,qDAAqD,EAAE;AACnG,4CAA4C,qDAAqD,EAAE;AACnG,4CAA4C,qDAAqD,EAAE;;AAEnG;EACE,UAAU;EACV,UAAU;EACV,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB;;uCAEqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;AACA;EACE,cAAc;EACd,4HAA4H;AAC9H;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,WAAW,0CAA0C,EAAE;EACvD,MAAM,6CAA6C,EAAE;AACvD;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA,sDAAsD,qDAAqD,EAAE;AAC7G,sDAAsD,qDAAqD,EAAE;AAC7G,sDAAsD,qDAAqD,EAAE;AAC7G,sDAAsD,qDAAqD,EAAE;AAC7G,sDAAsD,qDAAqD,EAAE;;AAE7G;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2EAA2E;EAC3E,gFAAgF;EAChF,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,iCAAiC;EACjC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,oBAAoB;EACpB,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,2CAA2C;EAC3C,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;EAChC,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,UAAU,EAAE;AACpB;;AAEA,oBAAoB;AACpB;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,mBAAmB;EACrB,EAAE;IACA,qBAAqB;EACvB;AACF;;AAEA,uCAAuC;AACvC;EACE,cAAc;EACd,qEAAqE;EACrE,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,+CAA+C;EAC/C,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,6BAA6B;AAC/B;;AAEA;;EAEE,qEAAqE;EACrE,uBAAuB;AACzB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,qEAAqE;AACvE;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qEAAqE;EACrE,uEAAuE;EACvE;;;;GAIC;AACH;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,sEAAsE;EACtE,+CAA+C;EAC/C,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,mDAAmD;EACnD,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,yCAAyC;EACzC,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,yCAAyC;EACzC,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,WAAW;AACb;;AAEA;EACE,6FAA6F;EAC7F,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,iCAAiC;AACnC;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA,2BAA2B;AAC3B;EACE;IACE;;;;iDAI6C;EAC/C;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B;;;;KAIC;EACH;;EAEA;;IAEE,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,qEAAqE;IACrE;;;;KAIC;EACH;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,wBAAwB;EACxB,oBAAoB;EACpB;;;;kCAIgC;AAClC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,MAAM;EACN,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE;IACE;;;;oCAIgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF","sourcesContent":["/* AI Profiling Wizard Stylesheet */\n\n@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');\n\n:root {\n  --wizard-bg: #0b0f19;\n  --wizard-slate-dark: #0f172a;\n  --wizard-slate-light: #1e293b;\n  --wizard-primary: var(--brand-primary, #0877bc);\n  --wizard-primary-dark: var(--brand-primary-dark, #065a8f);\n  --wizard-primary-gradient: linear-gradient(135deg, var(--wizard-primary) 0%, var(--wizard-primary-dark) 100%);\n  --wizard-accent: var(--brand-primary-light, #0a8cd8);\n  --wizard-accent-gradient: linear-gradient(135deg, var(--brand-secondary, #4facfe) 0%, var(--wizard-accent) 100%);\n  --wizard-text-main: #f8fafc;\n  --wizard-text-muted: #94a3b8;\n  --wizard-glass-bg: rgba(15, 23, 42, 0.75);\n  --wizard-glass-border: rgba(255, 255, 255, 0.08);\n}\n\n.wizard-full-bg {\n  position: fixed;\n  top: var(--wizard-vv-top, 0px);\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: var(--wizard-vvh, 100dvh);\n  max-height: var(--wizard-vvh, 100dvh);\n  min-height: 0;\n  background-color: var(--wizard-bg);\n  background-image: \n    radial-gradient(at 0% 0%, color-mix(in srgb, var(--wizard-primary) 15%, transparent) 0px, transparent 50%),\n    radial-gradient(at 100% 100%, color-mix(in srgb, var(--wizard-accent) 8%, transparent) 0px, transparent 50%),\n    linear-gradient(rgba(255, 255, 255, 0.01) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.01) 1px, transparent 1px);\n  background-size: 100% 100%, 100% 100%, 30px 30px, 30px 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding:\n    max(0.5rem, env(safe-area-inset-top, 0px))\n    max(0.75rem, env(safe-area-inset-right, 0px))\n    max(0.35rem, var(--wizard-safe-bottom, env(safe-area-inset-bottom, 0px)))\n    max(0.75rem, env(safe-area-inset-left, 0px));\n  box-sizing: border-box;\n  font-family: 'Outfit', 'Inter', -apple-system, sans-serif;\n  color: var(--wizard-text-main);\n  overflow: hidden;\n  z-index: 20;\n}\n\n/* 1. Introduction Card */\n.wizard-intro-card {\n  width: 100%;\n  max-width: 640px;\n  max-height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--wizard-glass-bg);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid var(--wizard-glass-border);\n  border-radius: 24px;\n  padding: 2.5rem;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n.wizard-intro-card:has(> .wizard-intro-card__body) {\n  overflow: hidden;\n}\n\n.wizard-intro-card__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.wizard-intro-card__cta {\n  flex: 0 0 auto;\n  padding-top: 0.85rem;\n}\n\n.wizard-intro-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  padding-bottom: 1.2rem;\n}\n\n.logo-badge {\n  font-size: 2.2rem;\n  background: rgba(255, 255, 255, 0.05);\n  width: 56px;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-boot-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1.1rem;\n  padding: 2rem 1.25rem;\n  text-align: center;\n}\n\n.invite-splash-screen {\n  width: 100%;\n  min-height: var(--wizard-vvh, 100dvh);\n  height: var(--wizard-vvh, 100dvh);\n  background: #ffffff;\n  color: #111827;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: max(0.5rem, env(safe-area-inset-top, 0px)) max(0.75rem, env(safe-area-inset-right, 0px)) max(0.5rem, env(safe-area-inset-bottom, 0px)) max(0.75rem, env(safe-area-inset-left, 0px));\n  box-sizing: border-box;\n}\n\n.invite-splash-screen .intro-body-text {\n  color: #111827;\n}\n\n.invite-splash-logos {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1.6rem;\n}\n\n.invite-splash-logos__club,\n.invite-splash-logos__smarttt {\n  object-fit: contain;\n  display: block;\n}\n\n.invite-splash-logos__club {\n  width: 128px;\n  height: 128px;\n  padding: 0;\n  border-radius: 22px;\n  background: transparent;\n  box-sizing: border-box;\n}\n\n.invite-splash-logos__smarttt {\n  width: 112px;\n  height: auto;\n  max-height: 128px;\n}\n\n.logo-badge--digiping {\n  background: radial-gradient(\n    circle at 30% 25%,\n    color-mix(in srgb, var(--wizard-accent) 20%, transparent),\n    color-mix(in srgb, var(--wizard-primary) 12%, transparent) 55%,\n    rgba(15, 23, 42, 0.6)\n  );\n  border-color: color-mix(in srgb, var(--wizard-accent) 35%, transparent);\n  box-shadow: 0 0 24px color-mix(in srgb, var(--wizard-accent) 15%, transparent);\n}\n\n.wizard-intro-titles {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  min-width: 0;\n}\n\n.wizard-join-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.45rem 0.55rem;\n  width: fit-content;\n  max-width: 100%;\n}\n\n.wizard-join-banner {\n  display: inline-flex;\n  align-items: center;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--wizard-text-main);\n  background: color-mix(in srgb, var(--wizard-primary) 22%, transparent);\n  border: 1px solid color-mix(in srgb, var(--wizard-primary) 40%, transparent);\n  border-radius: 999px;\n  padding: 0.28rem 0.75rem;\n  margin-bottom: 0.15rem;\n  width: fit-content;\n}\n\n.wizard-join-banner--compact {\n  font-size: 0.72rem;\n  padding: 0.18rem 0.6rem;\n}\n\n.wizard-intro-card .lang-shortcut--invite .lang-shortcut__btn {\n  background: color-mix(in srgb, var(--wizard-primary, #0877bc) 22%, transparent);\n  border: 1px solid color-mix(in srgb, var(--wizard-primary, #0877bc) 40%, transparent);\n  color: var(--wizard-text-main, #f8fafc);\n  box-shadow: none;\n}\n\n.wizard-intro-card .lang-shortcut--invite .lang-shortcut__btn:hover {\n  transform: scale(1.04);\n  background: color-mix(in srgb, var(--wizard-primary, #0877bc) 32%, transparent);\n}\n\n.wizard-intro-card .lang-shortcut--invite .lang-shortcut__btn.is-open {\n  background: var(--wizard-primary, #0877bc);\n  border-color: var(--wizard-primary, #0877bc);\n  color: #fff;\n}\n\n.wizard-intro-card .lang-shortcut--invite .lang-shortcut__panel {\n  background: rgba(15, 23, 42, 0.96);\n  color: #f8fafc;\n  border: 1px solid color-mix(in srgb, var(--wizard-primary, #0877bc) 35%, transparent);\n}\n\n.wizard-intro-card .lang-shortcut--invite .lang-shortcut__option {\n  color: #f8fafc;\n}\n\n.wizard-join-logo {\n  width: 44px;\n  height: 44px;\n  object-fit: contain;\n  border-radius: 12px;\n}\n\n.wizard-join-logo--sm {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n}\n\n.digiping-tag {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--wizard-accent);\n}\n\n.wizard-intro-header h2 {\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin: 0;\n  background: linear-gradient(to right, #ffffff, #94a3b8);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.intro-body-text {\n  font-size: 1.05rem;\n  line-height: 1.6;\n  color: var(--wizard-text-muted);\n  margin-bottom: 1.8rem;\n}\n\n.intro-body-text .dp-rich-text,\n.intro-body-text .dp-rich-p {\n  margin: 0;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n}\n\n.intro-body-text.typewriter-streaming,\n.intro-action-prompt.typewriter-streaming {\n  position: relative;\n}\n\n.intro-body-text.typewriter-streaming > .dp-rich-text,\n.intro-action-prompt.typewriter-streaming > .dp-rich-text,\n.intro-body-text.typewriter-streaming .dp-rich-p,\n.intro-action-prompt.typewriter-streaming .dp-rich-p,\n.intro-body-text.typewriter-streaming .dp-rich-line,\n.intro-action-prompt.typewriter-streaming .dp-rich-line {\n  display: inline;\n}\n\n.intro-body-text .typewriter-caret,\n.intro-action-prompt .typewriter-caret,\n.smart-desc .typewriter-caret,\n.typewriter-streaming > .typewriter-caret {\n  display: inline-block;\n  width: 2px;\n  height: 1.05em;\n  margin-left: 2px;\n  vertical-align: text-bottom;\n  background: var(--wizard-accent, #22d3ee);\n  border-radius: 1px;\n  animation: typewriterBlink 0.85s step-end infinite;\n}\n\n.smart-bullet--streaming {\n  border-color: rgba(8, 119, 188, 0.35);\n  background: rgba(8, 119, 188, 0.06);\n}\n\n.intro-stream-status {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  margin-top: 0.5rem;\n  color: var(--wizard-text-muted);\n  font-size: 0.9rem;\n}\n\n.intro-stream-status__label {\n  opacity: 0.85;\n}\n\n/* SMART Grid */\n.smart-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-bottom: 2rem;\n}\n\n.smart-bullet {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.9rem;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.04);\n  padding: 0.95rem 1.1rem;\n  border-radius: 14px;\n  transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;\n}\n\n.smart-bullet:hover {\n  transform: translateX(4px);\n  border-color: rgba(8, 119, 188, 0.3);\n  background: rgba(8, 119, 188, 0.02);\n}\n\n.smart-letter {\n  flex-shrink: 0;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 0.95rem;\n  letter-spacing: 0.02em;\n  color: #0b0f19;\n}\n\n.smart-bullet--s .smart-letter { background: linear-gradient(135deg, #22d3ee, #0891b2); }\n.smart-bullet--m .smart-letter { background: linear-gradient(135deg, #34d399, #059669); }\n.smart-bullet--a .smart-letter { background: linear-gradient(135deg, #fbbf24, #d97706); }\n.smart-bullet--r .smart-letter { background: linear-gradient(135deg, #fb7185, #e11d48); }\n.smart-bullet--t .smart-letter { background: linear-gradient(135deg, #a78bfa, #7c3aed); }\n\n.smart-bullet-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  min-width: 0;\n}\n\n.smart-label {\n  font-size: 0.98rem;\n  line-height: 1.3;\n}\n\n.smart-desc {\n  font-size: 0.92rem;\n  line-height: 1.45;\n  color: var(--wizard-text-muted);\n}\n\n.smart-desc.dp-rich-text,\n.smart-desc .dp-rich-p,\n.smart-desc .dp-rich-line {\n  margin: 0;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n}\n\n/* Digiping emphasis (replaces **markdown**) */\n.dp-em {\n  font-weight: 800;\n  font-style: normal;\n  letter-spacing: 0.02em;\n  font-family: 'Outfit', 'Avenir Next', 'Segoe UI', sans-serif;\n}\n\n.dp-em--s,\n.dp-em--specific { color: #22d3ee; }\n.dp-em--m { color: #34d399; }\n.dp-em--a { color: #fbbf24; }\n.dp-em--r { color: #fb7185; }\n.dp-em--t { color: #a78bfa; }\n.dp-em--smart {\n  background: var(--wizard-accent-gradient);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: var(--wizard-accent);\n}\n.dp-em--goal { color: #38bdf8; }\n.dp-em--default { color: var(--wizard-accent); }\n\n.dp-rich-text {\n  margin: 0;\n}\n\n.dp-rich-line {\n  display: inline;\n}\n\n.dp-rich-bullet {\n  position: relative;\n  padding-left: 1.05rem;\n  margin: 0.45rem 0 0.15rem;\n  line-height: 1.55;\n}\n\n.dp-rich-bullet::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0.55em;\n  width: 0.4rem;\n  height: 0.4rem;\n  border-radius: 50%;\n  background: var(--wizard-accent);\n  box-shadow: 0 0 8px rgba(0, 242, 254, 0.55);\n}\n\n.intro-action-prompt {\n  font-size: 1rem;\n  color: var(--wizard-accent);\n  font-weight: 500;\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.wizard-begin-btn {\n  width: 100%;\n  padding: 1.1rem;\n  border-radius: 14px;\n  border: none;\n  background: var(--wizard-primary-gradient);\n  color: var(--wizard-text-main);\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.8rem;\n  box-shadow: 0 10px 20px -5px rgba(8, 119, 188, 0.4);\n  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.wizard-begin-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 15px 30px -5px rgba(8, 119, 188, 0.6);\n  filter: brightness(1.1);\n}\n\n.intro-resume-hint {\n  margin: 0 0 1rem;\n  font-size: 0.95rem;\n  color: var(--wizard-text-muted, rgba(255, 255, 255, 0.72));\n  text-align: center;\n}\n\n.wizard-begin-btn--secondary {\n  margin-top: 0.75rem;\n  background: transparent;\n  border: 1px solid var(--wizard-glass-border, rgba(255, 255, 255, 0.2));\n  box-shadow: none;\n  font-size: 0.95rem;\n}\n\n.wizard-begin-btn--secondary:hover {\n  box-shadow: none;\n  filter: none;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n/* 2. Chat Interface Container */\n.wizard-chat-container {\n  width: 100%;\n  max-width: 760px;\n  flex: 1 1 auto;\n  height: 100%;\n  max-height: 100%;\n  min-height: 0;\n  background: var(--wizard-glass-bg);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--wizard-glass-border);\n  border-radius: 28px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 0 30px 60px -15px rgba(0, 0, 0, 0.6);\n}\n\n.wizard-chat-header {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem 0.85rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  background: rgba(8, 15, 28, 0.55);\n}\n\n.wizard-chat-header__brand {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.wizard-chat-header__brand .lang-shortcut--invite {\n  margin-left: auto;\n}\n\n.wizard-chat-header__brand .lang-shortcut--invite .lang-shortcut__panel {\n  right: 0;\n  left: auto;\n}\n\n.wizard-chat-header__text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 0;\n}\n\n.wizard-chat-header__text .coach-label {\n  margin-bottom: 0;\n}\n\n.coach-avatar--header {\n  width: 36px;\n  height: 36px;\n}\n\n.coach-label-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem 0.65rem;\n  margin-bottom: 0.4rem;\n}\n\n.coach-label-row .coach-label {\n  margin-bottom: 0;\n}\n\n.dimension-chip {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n/* Digiping SMART progress rail */\n.digiping-smart-rail {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.digiping-smart-rail__track {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0;\n  padding-bottom: 0.65rem;\n}\n\n.digiping-smart-rail__link {\n  flex: 1;\n  height: 2px;\n  margin: 0 0.2rem;\n  border-radius: 2px;\n  background: rgba(255, 255, 255, 0.08);\n  transition: background 0.3s ease;\n}\n\n.digiping-smart-rail__link--complete,\n.digiping-smart-rail__link--partial {\n  background: linear-gradient(90deg, rgba(79, 172, 254, 0.55), rgba(0, 242, 254, 0.35));\n}\n\n.digiping-smart-rail__node {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  border: 1.5px solid rgba(255, 255, 255, 0.12);\n  background: rgba(15, 23, 42, 0.9);\n  color: var(--wizard-text-muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  cursor: default;\n  flex-shrink: 0;\n  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease, background 0.25s ease;\n}\n\n.digiping-smart-rail__node:disabled {\n  opacity: 1;\n}\n\n.digiping-smart-rail__node:not(:disabled) {\n  cursor: pointer;\n}\n\n.digiping-smart-rail__letter {\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.digiping-smart-rail__node.is-empty {\n  opacity: 0.55;\n}\n\n.digiping-smart-rail__node.is-partial {\n  animation: digipingPulse 1.6s ease-in-out infinite;\n}\n\n.digiping-smart-rail__node.is-complete {\n  color: #0b0f19;\n  border-color: transparent;\n}\n\n.digiping-smart-rail__node--s.is-complete { background: linear-gradient(135deg, #22d3ee, #0891b2); }\n.digiping-smart-rail__node--m.is-complete { background: linear-gradient(135deg, #34d399, #059669); }\n.digiping-smart-rail__node--a.is-complete { background: linear-gradient(135deg, #fbbf24, #d97706); }\n.digiping-smart-rail__node--r.is-complete { background: linear-gradient(135deg, #fb7185, #e11d48); }\n.digiping-smart-rail__node--t.is-complete { background: linear-gradient(135deg, #a78bfa, #7c3aed); }\n\n.digiping-smart-rail__node.is-active {\n  opacity: 1;\n  z-index: 2;\n  transform: scale(1.18);\n  outline: 2px solid currentColor;\n  outline-offset: 3px;\n  box-shadow:\n    0 0 0 4px rgba(0, 242, 254, 0.35),\n    0 10px 24px rgba(0, 242, 254, 0.28);\n  border-color: currentColor;\n}\n\n.digiping-smart-rail__node--s.is-active {\n  color: #0891b2;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #22d3ee 45%, transparent), 0 10px 24px color-mix(in srgb, #22d3ee 32%, transparent);\n}\n.digiping-smart-rail__node--m.is-active {\n  color: #059669;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #34d399 45%, transparent), 0 10px 24px color-mix(in srgb, #34d399 32%, transparent);\n}\n.digiping-smart-rail__node--a.is-active {\n  color: #d97706;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #fbbf24 45%, transparent), 0 10px 24px color-mix(in srgb, #fbbf24 32%, transparent);\n}\n.digiping-smart-rail__node--r.is-active {\n  color: #e11d48;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #fb7185 45%, transparent), 0 10px 24px color-mix(in srgb, #fb7185 32%, transparent);\n}\n.digiping-smart-rail__node--t.is-active {\n  color: #7c3aed;\n  box-shadow: 0 0 0 4px color-mix(in srgb, #a78bfa 45%, transparent), 0 10px 24px color-mix(in srgb, #a78bfa 32%, transparent);\n}\n\n.digiping-smart-rail__node.is-active.is-complete {\n  color: #0b0f19;\n  outline-color: rgba(255, 255, 255, 0.85);\n}\n\n.digiping-smart-rail__node.is-coach-pending {\n  position: relative;\n  border-color: rgba(251, 191, 36, 0.75);\n}\n\n.digiping-smart-rail__coach {\n  position: absolute;\n  bottom: -0.55rem;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 0.5rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  padding: 0.1rem 0.28rem;\n  border-radius: 4px;\n  background: rgba(251, 191, 36, 0.95);\n  color: #1a1408;\n  line-height: 1.1;\n}\n\n.digiping-smart-rail__caption {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  text-align: center;\n}\n\n.digiping-coach-banner {\n  margin: 0.35rem 0 0.85rem;\n  padding: 0.65rem 0.8rem;\n  border-radius: 10px;\n  background: rgba(251, 191, 36, 0.12);\n  border: 1px solid rgba(251, 191, 36, 0.35);\n  color: var(--wizard-text-muted);\n  font-size: 0.88rem;\n  line-height: 1.4;\n}\n\n.digiping-coach-pill {\n  display: inline-block;\n  margin-left: 0.4rem;\n  padding: 0.08rem 0.35rem;\n  border-radius: 4px;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  vertical-align: middle;\n  background: rgba(251, 191, 36, 0.95);\n  color: #1a1408;\n}\n\n.digiping-snapshot-row.has-coach-badge {\n  border-color: rgba(251, 191, 36, 0.35);\n}\n\n.digiping-tray-input {\n  width: 100%;\n  margin-top: 0.55rem;\n}\n\n.digiping-training-volume-tray .tray-subtitle {\n  margin-top: 0.65rem;\n}\n\n.digiping-training-volume-tray .tray-subtitle:first-child {\n  margin-top: 0;\n}\n\n.digiping-training-volume-tray .badge-grid {\n  margin-bottom: 0.25rem;\n}\n\n.digiping-metric-target-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 0.55rem;\n}\n\n.digiping-metric-unit {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--wizard-text-muted);\n  white-space: nowrap;\n}\n\n.digiping-coach-hint {\n  color: rgba(251, 191, 36, 0.95) !important;\n}\n\n.digiping-milestone-chip {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n}\n\n.digiping-horizon-tag {\n  font-size: 0.65rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  padding: 0.12rem 0.35rem;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.12);\n  color: rgba(255, 255, 255, 0.9);\n}\n\n@keyframes digipingPulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(0, 242, 254, 0.0); }\n  50% { box-shadow: 0 0 0 4px rgba(0, 242, 254, 0.18); }\n}\n\n/* Digiping SMART snapshot (assessment) */\n.digiping-snapshot-card .assessment-body {\n  margin-top: 1rem;\n}\n\n.digiping-snapshot-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  opacity: 0;\n  transform: translateY(6px);\n  transition: opacity 0.35s ease, transform 0.35s ease;\n}\n\n.digiping-snapshot-grid.is-visible {\n  opacity: 1;\n  transform: none;\n}\n\n.digiping-snapshot-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.7rem 0.85rem;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.digiping-snapshot-letter {\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 0.85rem;\n  color: #0b0f19;\n  flex-shrink: 0;\n}\n\n.digiping-snapshot-row--s .digiping-snapshot-letter { background: linear-gradient(135deg, #22d3ee, #0891b2); }\n.digiping-snapshot-row--m .digiping-snapshot-letter { background: linear-gradient(135deg, #34d399, #059669); }\n.digiping-snapshot-row--a .digiping-snapshot-letter { background: linear-gradient(135deg, #fbbf24, #d97706); }\n.digiping-snapshot-row--r .digiping-snapshot-letter { background: linear-gradient(135deg, #fb7185, #e11d48); }\n.digiping-snapshot-row--t .digiping-snapshot-letter { background: linear-gradient(135deg, #a78bfa, #7c3aed); }\n\n.digiping-snapshot-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.digiping-snapshot-summary {\n  font-size: 0.88rem;\n  line-height: 1.4;\n  color: var(--wizard-text-muted);\n}\n\n/* Chat History Stream */\n.wizard-chat-history {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 1.5rem 2rem 1.25rem;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;\n}\n\n.wizard-chat-history__spacer {\n  flex: 0 0 auto;\n  height: 0.5rem;\n  width: 100%;\n  pointer-events: none;\n}\n\n.wizard-chat-history::-webkit-scrollbar {\n  width: 6px;\n}\n\n.wizard-chat-history::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n}\n\n/* Chat Rows & Bubbles */\n.ai-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.8rem;\n  align-self: flex-start;\n  max-width: 80%;\n}\n\n.user-row {\n  align-self: flex-end;\n  max-width: 80%;\n}\n\n.system-row {\n  align-self: center;\n  max-width: 90%;\n  margin: 0.8rem 0;\n}\n\n.coach-avatar {\n  width: 38px;\n  height: 38px;\n  background: radial-gradient(\n    circle at 30% 25%,\n    color-mix(in srgb, var(--wizard-accent) 28%, transparent),\n    color-mix(in srgb, var(--wizard-primary) 45%, transparent) 60%,\n    var(--wizard-primary-dark)\n  );\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid color-mix(in srgb, var(--wizard-accent) 35%, transparent);\n  box-shadow: 0 4px 14px color-mix(in srgb, var(--wizard-accent) 18%, transparent);\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.digiping-mark {\n  display: block;\n  flex-shrink: 0;\n}\n\n.ai-bubble {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 4px 18px 18px 18px;\n  padding: 1rem 1.3rem;\n  position: relative;\n}\n\n.coach-label {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--wizard-accent);\n  display: block;\n  margin-bottom: 0.4rem;\n}\n\n.user-bubble {\n  background: var(--wizard-primary-gradient);\n  border-radius: 18px 18px 4px 18px;\n  padding: 1rem 1.3rem;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 16px -4px rgba(8, 119, 188, 0.3);\n}\n\n.user-answer-row {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.45rem;\n}\n\n.edit-answer-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin: 0;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  background: rgba(0, 0, 0, 0.18);\n  color: rgba(255, 255, 255, 0.92);\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n}\n\n.edit-answer-btn:hover {\n  background: rgba(0, 0, 0, 0.32);\n  border-color: rgba(255, 255, 255, 0.45);\n}\n\n.editing-hint {\n  margin: 0 0 0.75rem;\n  text-align: center;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: var(--wizard-accent);\n}\n\n.msg-content-text {\n  font-size: 1.02rem;\n  line-height: 1.5;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.typewriter-text {\n  min-height: 1.5em;\n}\n\n.typewriter-caret {\n  display: inline-block;\n  width: 2px;\n  height: 1.05em;\n  margin-left: 2px;\n  vertical-align: text-bottom;\n  background: var(--wizard-accent);\n  border-radius: 1px;\n  animation: typewriterBlink 0.85s step-end infinite;\n}\n\n@keyframes typewriterBlink {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0; }\n}\n\n/* System Messages */\n.system-msg-box {\n  background: rgba(8, 119, 188, 0.12);\n  border: 1px solid rgba(8, 119, 188, 0.25);\n  border-radius: 12px;\n  padding: 0.8rem 1.5rem;\n  text-align: center;\n}\n\n.system-msg-box p {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #c0e0ff;\n  font-weight: 500;\n}\n\n/* 3. Typing Indicator Animation */\n.typing-bubble {\n  display: flex;\n  flex-direction: column;\n}\n\n.typing-indicator-dots {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 20px;\n}\n\n.typing-indicator-dots span {\n  width: 8px;\n  height: 8px;\n  background: var(--wizard-text-muted);\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounceDot 1.4s infinite ease-in-out both;\n}\n\n.typing-indicator-dots span:nth-child(1) {\n  animation-delay: -0.32s;\n}\n\n.typing-indicator-dots span:nth-child(2) {\n  animation-delay: -0.16s;\n}\n\n@keyframes bounceDot {\n  0%, 80%, 100% { \n    transform: scale(0);\n  } 40% { \n    transform: scale(1.0);\n  }\n}\n\n/* 4. Interactive Footer Options Tray */\n.wizard-interactive-footer {\n  flex: 0 0 auto;\n  max-height: min(36dvh, calc(var(--wizard-vvh, 100dvh) * 0.36), 280px);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  background: rgba(10, 15, 28, 0.92);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  padding: 0.65rem 1.25rem 0.85rem;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 -12px 28px rgba(0, 0, 0, 0.35);\n  scroll-margin-bottom: 0.35rem;\n}\n\nhtml.wizard-keyboard-open .wizard-interactive-footer,\nbody.wizard-keyboard-open .wizard-interactive-footer {\n  max-height: min(42dvh, calc(var(--wizard-vvh, 100dvh) * 0.42), 220px);\n  padding-bottom: 0.35rem;\n}\n\nhtml.wizard-keyboard-open .wizard-full-bg,\nbody.wizard-keyboard-open .wizard-full-bg {\n  padding-bottom: 0.25rem;\n}\n\nhtml.wizard-keyboard-open .inline-input-field,\nhtml.wizard-keyboard-open .inline-input-field:focus,\nbody.wizard-keyboard-open .inline-input-field,\nbody.wizard-keyboard-open .inline-input-field:focus {\n  scroll-margin-bottom: 0.35rem;\n}\n\n/* Confirm trays: options scroll; Continue stays in the visible footer. */\n.wizard-interactive-footer:has(.options-badge-tray--sticky-confirm) {\n  overflow: hidden;\n  max-height: min(48dvh, calc(var(--wizard-vvh, 100dvh) * 0.48), 380px);\n}\n\n.options-badge-tray--sticky-confirm {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.options-badge-tray--sticky-confirm .badge-grid {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: none;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.options-badge-tray--sticky-confirm .tray-confirm-btn {\n  flex-shrink: 0;\n  width: 100%;\n  justify-content: center;\n  margin-top: 0.35rem;\n}\n\n.options-badge-tray--sticky-confirm .tray-confirm-hint {\n  flex-shrink: 0;\n  margin: 0;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--wizard-text-muted);\n  text-align: center;\n}\n\n.options-badge-tray--sticky-confirm .tray-confirm-hint kbd {\n  display: inline-block;\n  padding: 0.05rem 0.35rem;\n  border-radius: 4px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.06);\n  font-size: 0.7rem;\n  font-family: inherit;\n}\n\n.wizard-interactive-footer--assessment {\n  overflow: hidden;\n  max-height: min(72dvh, calc(var(--wizard-vvh, 100dvh) * 0.72), 640px);\n  /* Extra floor for Android gesture / Samsung nav when env() reports 0 */\n  padding-bottom: max(\n    1rem,\n    calc(env(safe-area-inset-bottom, 0px) + 16px),\n    var(--wizard-safe-bottom, 0px)\n  );\n}\n\n.wizard-interactive-footer:has(.assessment-tray--sticky-cta) {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.assessment-tray--sticky-cta {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  overflow: hidden;\n  width: 100%;\n}\n\n.assessment-tray--sticky-cta .assessment-card--body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.assessment-tray--sticky-cta .assessment-btn {\n  flex-shrink: 0;\n  width: 100%;\n  margin-top: 0;\n  /* Keep CTA clear of OS bottom chrome */\n  margin-bottom: max(0px, calc(env(safe-area-inset-bottom, 0px) * 0.15));\n  box-shadow: 0 -10px 24px rgba(10, 15, 28, 0.55);\n  z-index: 2;\n}\n\n/* Options Tray layout for cards */\n.options-tray {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.tray-card {\n  flex: 1 1 180px;\n  max-width: 230px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 1.2rem;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.6rem;\n  transition: all 0.25s cubic-bezier(0.25, 1, 0.5, 1);\n  color: var(--wizard-text-main);\n}\n\n.tray-card:hover {\n  background: rgba(8, 119, 188, 0.06);\n  border-color: rgba(8, 119, 188, 0.4);\n  transform: translateY(-3px);\n  box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.4);\n}\n\n.tray-icon {\n  font-size: 2rem !important;\n  color: var(--wizard-accent);\n}\n\n.tray-card-title {\n  font-size: 0.98rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n/* Badge selector tray layout */\n.options-badge-tray {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.tray-subtitle {\n  font-size: 0.95rem;\n  color: var(--wizard-text-muted);\n  margin: 0 0 0.2rem 0;\n  font-weight: 500;\n}\n\n.badge-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n}\n\n.max-height-tray {\n  max-height: 180px;\n  overflow-y: auto;\n  padding-right: 0.5rem;\n}\n\n.badge-button {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 12px;\n  padding: 0.75rem 1.1rem;\n  font-size: 0.92rem;\n  font-weight: 500;\n  color: var(--wizard-text-main);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.badge-button:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.15);\n  transform: translateY(-1px);\n}\n\n.badge-button.active-badge {\n  background: var(--wizard-primary-gradient);\n  border-color: rgba(8, 119, 188, 0.5);\n  box-shadow: 0 4px 12px rgba(8, 119, 188, 0.3);\n}\n\n.flag-span {\n  font-size: 1.2rem;\n}\n\n.align-left {\n  justify-content: flex-start;\n  text-align: left;\n  width: calc(50% - 0.3rem);\n  flex-grow: 1;\n}\n\n.tray-confirm-btn {\n  align-self: flex-end;\n  padding: 0.75rem 1.5rem;\n  background: var(--wizard-accent-gradient);\n  border: none;\n  color: #0b0f19;\n  font-weight: 700;\n  border-radius: 12px;\n  font-size: 0.95rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 4px 12px rgba(0, 242, 254, 0.25);\n  transition: all 0.2s ease;\n}\n\n.tray-confirm-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.tray-confirm-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 16px rgba(0, 242, 254, 0.45);\n}\n\n.tray-confirm-btn:focus-visible {\n  outline: 2px solid #00f2fe;\n  outline-offset: 3px;\n}\n\n/* 5. In-chat forms (Inputs & Autocomplete) */\n.search-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 0.6rem 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.search-field-icon {\n  color: var(--wizard-text-muted);\n}\n\n.search-input-field {\n  background: transparent;\n  border: none;\n  outline: none;\n  color: var(--wizard-text-main);\n  font-size: 0.98rem;\n  width: 100%;\n  scroll-margin-bottom: 1.5rem;\n}\n\n.inline-text-form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.inline-input-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 0.6rem 1rem;\n}\n\n.inline-input-field {\n  background: transparent;\n  border: none;\n  outline: none;\n  color: var(--wizard-text-main);\n  font-size: 1.05rem;\n  width: 100%;\n  scroll-margin-bottom: 0.5rem;\n}\n\n.inline-submit-btn {\n  background: var(--wizard-primary-gradient);\n  border: none;\n  color: white;\n  width: 38px;\n  height: 38px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.inline-submit-btn:hover {\n  transform: scale(1.05);\n}\n\n.inline-error-text {\n  font-size: 0.88rem;\n  color: #ff4a5a;\n  margin: 0.2rem 0 0 0.5rem;\n}\n\n.inline-error-login-link {\n  color: var(--brand-primary, #0877bc);\n  font-weight: 700;\n  text-decoration: underline;\n  white-space: nowrap;\n}\n\n.inline-error-login-link:hover {\n  opacity: 0.9;\n}\n\n/* Password double forms */\n.password-form-tray {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.password-fields-row {\n  display: flex;\n  gap: 1rem;\n}\n\n.password-input-group {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 0.6rem 1rem;\n  scroll-margin-bottom: 1.5rem;\n}\n\n.password-submit-btn {\n  align-self: flex-end;\n  padding: 0.8rem 1.8rem;\n  background: var(--wizard-accent-gradient);\n  border: none;\n  color: #0b0f19;\n  font-weight: 700;\n  border-radius: 12px;\n  font-size: 1rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.2s ease;\n}\n\n.password-submit-btn:hover {\n  transform: translateY(-1px);\n}\n\n/* 6. Assessment Dashboard */\n.assessment-tray {\n  width: 100%;\n}\n\n.assessment-card {\n  background: linear-gradient(135deg, rgba(8, 119, 188, 0.12) 0%, rgba(0, 242, 254, 0.05) 100%);\n  border: 1px solid rgba(8, 119, 188, 0.25);\n  border-radius: 20px;\n  padding: 1.8rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.assessment-card h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0;\n  color: var(--wizard-accent);\n}\n\n.assessment-card-head {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.assessment-body {\n  font-size: 0.98rem;\n  line-height: 1.6;\n  color: #e2e8f0;\n  margin: 0 0 1.5rem 0;\n  white-space: normal;\n}\n\n.assessment-btn {\n  width: 100%;\n  padding: 1rem;\n  background: var(--wizard-primary-gradient);\n  border: none;\n  color: white;\n  font-weight: 600;\n  font-size: 1.05rem;\n  border-radius: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  transition: all 0.2s ease;\n}\n\n.assessment-btn:hover {\n  filter: brightness(1.1);\n  transform: translateY(-1px);\n}\n\n/* Ripple effect utility */\n.ripple {\n  position: relative;\n  overflow: hidden;\n}\n\n/* Micro-animations */\n.animate-fade-in {\n  animation: fadeIn 0.45s ease both;\n}\n\n.animate-slide-up {\n  animation: slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n\n.animate-scale-up {\n  animation: scaleUp 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(18px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes scaleUp {\n  from { opacity: 0; transform: scale(0.92); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n/* Responsive adjustments */\n@media (max-width: 640px) {\n  .wizard-full-bg {\n    padding:\n      max(0.5rem, env(safe-area-inset-top, 0px))\n      max(0.5rem, env(safe-area-inset-right, 0px))\n      max(0.5rem, calc(env(safe-area-inset-bottom, 0px) + 12px), var(--wizard-safe-bottom, 0px))\n      max(0.5rem, env(safe-area-inset-left, 0px));\n  }\n  \n  .wizard-intro-card {\n    padding: 1.25rem 1.15rem 1rem;\n  }\n  \n  .wizard-intro-header h2 {\n    font-size: 1.4rem;\n  }\n\n  .wizard-chat-container {\n    height: 100%;\n    max-height: 100%;\n    border-radius: 18px;\n  }\n\n  .wizard-chat-header {\n    padding: 0.75rem 0.9rem 0.65rem;\n  }\n\n  .digiping-smart-rail__node {\n    width: 1.7rem;\n    height: 1.7rem;\n  }\n\n  .digiping-smart-rail__letter {\n    font-size: 0.68rem;\n  }\n\n  .wizard-interactive-footer {\n    max-height: min(38dvh, 260px);\n    padding: 0.65rem 0.9rem max(\n      0.65rem,\n      calc(env(safe-area-inset-bottom, 0px) + 12px),\n      var(--wizard-safe-bottom, 0px)\n    );\n  }\n\n  html.wizard-keyboard-open .wizard-interactive-footer,\n  body.wizard-keyboard-open .wizard-interactive-footer {\n    max-height: min(40dvh, 200px);\n    padding-bottom: 0.3rem;\n  }\n\n  .wizard-interactive-footer:has(.options-badge-tray--sticky-confirm) {\n    max-height: min(52dvh, 360px);\n  }\n\n  .wizard-interactive-footer--assessment {\n    max-height: min(68dvh, calc(var(--wizard-vvh, 100dvh) * 0.68), 520px);\n    padding-bottom: max(\n      1rem,\n      calc(env(safe-area-inset-bottom, 0px) + 20px),\n      var(--wizard-safe-bottom, 0px)\n    );\n  }\n\n  .assessment-tray--sticky-cta .assessment-btn {\n    padding: 0.9rem 1rem;\n    font-size: 1rem;\n  }\n\n  .ai-bubble, .user-bubble {\n    padding: 0.8rem 1.1rem;\n  }\n\n  .msg-content-text {\n    font-size: 0.95rem;\n  }\n\n  .options-tray {\n    gap: 0.6rem;\n  }\n\n  .tray-card {\n    flex: 1 1 120px;\n    padding: 0.8rem;\n    border-radius: 12px;\n  }\n\n  .tray-icon {\n    font-size: 1.5rem !important;\n  }\n\n  .tray-card-title {\n    font-size: 0.85rem;\n  }\n\n  .align-left {\n    width: 100%;\n  }\n\n  .password-fields-row {\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n}\n\n.leisure-fun-challenge-card {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 0.5rem 0;\n}\n\n.health-multi-choice {\n  display: grid;\n  gap: 12px;\n  width: 100%;\n}\n\n.leisure-fun-challenge-details {\n  display: grid;\n  gap: 0.75rem;\n  margin: 0;\n}\n\n.leisure-fun-challenge-details dt {\n  font-size: 0.75rem;\n  font-weight: 600;\n  opacity: 0.75;\n  margin-bottom: 0.15rem;\n}\n\n.leisure-fun-challenge-details dd {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.35;\n}\n\n.leisure-fun-challenge-cta {\n  margin-top: 0.25rem;\n}\n\n.options-tray .club-admin-health-intro {\n  width: 100%;\n  margin: 0 0 0.75rem;\n}\n\n.options-tray .club-admin-health-intro .who-capsule,\n.options-tray .club-admin-health-intro .scforh-intro {\n  max-height: 42vh;\n  overflow-y: auto;\n}\n\n/* Player profiling chat: thin title, conversation fills the viewport. */\n.wizard-full-bg.wizard-full-bg--chat {\n  justify-content: stretch;\n  align-items: stretch;\n  padding:\n    env(safe-area-inset-top, 0px)\n    env(safe-area-inset-right, 0px)\n    env(safe-area-inset-bottom, 0px)\n    env(safe-area-inset-left, 0px);\n}\n\n.wizard-chat-container.wizard-chat-container--fill {\n  max-width: none;\n  width: 100%;\n  height: 100%;\n  border-radius: 0;\n  border-left: none;\n  border-right: none;\n  box-shadow: none;\n}\n\n.wizard-chat-header.wizard-chat-header--compact {\n  flex-direction: row;\n  align-items: center;\n  gap: 0;\n  padding: 0.28rem 0.7rem;\n}\n\n.wizard-chat-header--compact .wizard-chat-header__brand {\n  flex: 1 1 auto;\n  min-width: 0;\n  gap: 0.45rem;\n}\n\n.wizard-chat-header--compact .coach-avatar--header {\n  width: 26px;\n  height: 26px;\n}\n\n.wizard-chat-header--compact .wizard-join-logo--sm {\n  width: 22px;\n  height: 22px;\n}\n\n.wizard-chat-header--compact .wizard-chat-header__text {\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 0.4rem;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.wizard-chat-header--compact .wizard-chat-header__text .coach-label {\n  font-size: 0.78rem;\n  letter-spacing: 0.04em;\n  margin-bottom: 0;\n  white-space: nowrap;\n  flex: 0 0 auto;\n}\n\n.wizard-chat-header--compact .wizard-chat-header__text .digiping-tag {\n  font-size: 0.62rem;\n  letter-spacing: 0.06em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.wizard-chat-header--compact .wizard-join-banner--compact {\n  margin-bottom: 0;\n  flex: 0 1 auto;\n  min-width: 0;\n  max-width: 38%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.wizard-full-bg--chat .wizard-chat-history {\n  padding: 0.7rem 1rem 0.6rem;\n  gap: 1rem;\n}\n\n@media (max-width: 640px) {\n  .wizard-full-bg.wizard-full-bg--chat {\n    padding:\n      env(safe-area-inset-top, 0px)\n      env(safe-area-inset-right, 0px)\n      max(0.2rem, env(safe-area-inset-bottom, 0px), var(--wizard-safe-bottom, 0px))\n      env(safe-area-inset-left, 0px);\n  }\n\n  .wizard-chat-header.wizard-chat-header--compact {\n    padding: 0.22rem 0.55rem;\n  }\n\n  .wizard-full-bg--chat .wizard-chat-history {\n    padding: 0.55rem 0.7rem 0.45rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
